import { View } from './view'

export const About = View
